const mobileMenu = () => {
  const mainNav = document.querySelector('.main-nav__wrapper');

  if (!mainNav) {
    return;
  }

  const menuToggler = document.querySelector('.main-nav__button--toggler');
  const body = document.querySelector('body');
  const wrapper = document.querySelector('.wrapper');
  const mainNavMobile = document.querySelector('.main-nav__list--mobile');
  const tabs = document.querySelectorAll('.menu-tab');
  const mobileLinks = mainNavMobile.querySelectorAll('.main-nav__item');
  const arrowBack = document.querySelectorAll('.arrow-back');
  const headerGoodyCaps = document.querySelector('.header--goody-caps');


  if (headerGoodyCaps) {
    window.addEventListener('resize', function () {
      if (screen.width > 1024) {
        body.classList.remove('mobile-menu');
      }
    });
  }

  menuToggler.addEventListener('click', function () {
    let ariaLabel = menuToggler.getAttribute('aria-label');
    if (ariaLabel === 'Открыть меню') {
      menuToggler.setAttribute('aria-label', 'Закрыть меню');
    } else {
      menuToggler.setAttribute('aria-label', 'Открыть меню');
    }
    body.classList.toggle('mobile-menu');
    wrapper.classList.toggle('wrapper--no-scrollbar');
    mainNav.classList.add('show');
    tabs.forEach((e) => {
      e.classList.remove('show');
    });
  });

  mobileLinks.forEach((e) => {
    e.addEventListener('click', function () {
      let id = e.getAttribute('data-id');
      let tab = document.getElementById(id);
      tab.classList.add('show');
      mainNav.classList.remove('show');
      tabs.forEach((i) => {
        if (i.id !== id) {
          i.classList.remove('show');
        }
      });
    });
  });

  document.addEventListener('keydown', function (evt) {
    if (evt.key === 'Escape') {
      body.classList.remove('mobile-menu');
    }
  });

  arrowBack.forEach((el) => {
    el.addEventListener('click', function () {
      mainNav.classList.add('show');
      tabs.forEach((e) => {
        e.classList.remove('show');
      });
    });
  });
};

export {mobileMenu};
